import React from "react";
import styled from "styled-components";
import { format } from "date-fns"; // optional, if you want to format dates nicely
import { formatNumber } from "../utils/statsUtils";

const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 6px;
  padding-left: 1px;
  @media (max-width: 800px) {
    padding: 20px 0px;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const DateLabel = styled.div`
  font-weight: 700;
  font-size: 1rem;
  width: 100px;
  flex-shrink: 0;
  margin-top: 4px;
`;

const BarWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-top: 4px;
`;

const BarContainer = styled.div`
  width: 100%;
  height: 16px;
  background: #f0f0f0;
  border-radius: 8px;
  position: relative;
`;

const Bar = styled.div`
  height: 100%;
  background: #5dbcd2;
  width: ${({ widthPercent }) => widthPercent}%;
  border-radius: 8px;
  transition: width 0.3s ease;
`;

const BarLabel = styled.div`
  font-size: 0.8rem;
  color: #888;
  text-align: center;
  margin-top: 6px;
`;

export default function TopDaysChart({ data, unit }) {
  if (!data || Object.keys(data).length === 0) return null;

  const sorted = Object.entries(data)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 5);

  const max = sorted[0][1];

  return (
    <ChartWrapper>
      {sorted.map(([date, value], idx) => {
        const widthPercent = (value / max) * 100;
        const displayDate = format(new Date(date), "yyyy-MM-dd");

        return (
          <Row key={idx}>
            <DateLabel>{displayDate}</DateLabel>
            <BarWrapper>
              <BarContainer>
                <Bar widthPercent={widthPercent} />
              </BarContainer>
              <BarLabel>
                {formatNumber(value)} {unit}
              </BarLabel>
            </BarWrapper>
          </Row>
        );
      })}
    </ChartWrapper>
  );
}
